const SvgComponent = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none">
    <path
      fill="#222"
      fillRule="evenodd"
      d="M12.156 8.983A8 8 0 1 1 16 24a8.009 8.009 0 0 1-8-8c0-1.922.678-3.685 1.807-5.065.056.308.192.588.386.817-.31.424-.577.885-.793 1.378l4.346-.488 1.634-3.81a7.203 7.203 0 0 0-2.49.681 1.757 1.757 0 0 0-.734-.53ZM8.8 16c0 1.924.772 3.768 2.143 5.118l1.39-4.02L9.01 14.3A7.17 7.17 0 0 0 8.8 16Zm8.81-2.829L16 9.415l-1.61 3.756a.4.4 0 0 1-.323.24l-4.298.483 3.289 2.77a.4.4 0 0 1 .12.436l-1.359 3.933 4.084-1.021a.404.404 0 0 1 .194 0l4.084 1.02-1.36-3.932a.4.4 0 0 1 .121-.437l3.288-2.77-4.297-.482a.4.4 0 0 1-.323-.24Zm-5.784 8.685a7.152 7.152 0 0 0 8.348 0L16 20.812l-4.174 1.044Zm9.23-.738a7.13 7.13 0 0 0 1.933-6.817l-3.321 2.797 1.389 4.02ZM22.6 13.13a7.21 7.21 0 0 0-5.98-4.299l1.634 3.81 4.346.489Z"
      clipRule="evenodd"
    />
    <path
      fill="#222"
      fillRule="evenodd"
      d="M23.992 22.012A9.985 9.985 0 0 1 16 26c-5.523 0-10-4.477-10-10 .006-5.52 4.48-9.994 10-10 5.523 0 10 4.477 10 10 0 .793-.092 1.565-.267 2.304a2.247 2.247 0 0 0-.702-.541A9.2 9.2 0 0 0 16 6.8 9.21 9.21 0 0 0 6.8 16a9.2 9.2 0 0 0 16.328 5.817c.264.12.557.188.864.195Z"
      clipRule="evenodd"
    />
  </svg>
)
export { SvgComponent as Bonus }
